//@flow
import * as React from 'react'
import WrapCheckbox from '../common/WrapCheckbox'
import ListItem from 'material-ui/List/ListItem'
import {Field} from 'redux-form'
import SimpleMultiAnswersQuestion from './SimpleMultiAnswersQuestion'
import type { YesNoCheckboxItem$Props,YesNoCheckboxItem$State } from './flowTypes'
const YES = 'Yes'
const NO = 'No'

class YesNoCheckboxItem extends React.Component<YesNoCheckboxItem$Props,YesNoCheckboxItem$State> {
    state = {
        showSubAnswers: false
    }

    constructor(){
        super()
    }

    checkboxOnChange(e:any,type:string){
        if (e.target.checked && type==YES){
            this.props.changeFieldValue(`${this.props.elementId}_${NO}`,false)
        }else {
            this.props.changeFieldValue(`${this.props.elementId}_${YES}`,false)
        }
        let showSubAnswers = e.target.checked && type == YES?true:false

        this.setState({ showSubAnswers })
    }

    render(){
        return (
            <ListItem disableGutters={true} dense={true}>
                <div className='container'>
                    <div className='row'>
                       <div className='col-sm'>
                            <Field 
                            name={`${this.props.elementId}_${YES}`}
                            component={WrapCheckbox}
                            label={YES}
                            onChange={(e) => this.checkboxOnChange(e,YES)}
                            />
                        </div>
                   </div>
                   
                   {this.state.showSubAnswers && this.props.yesSubAnswers?(
                   <div className='row' >
                       <div className='col-sm'>
                            <div style={{paddingLeft: '50px'}}>
                                <label>
                                    {this.props.yesSubQuestionText}
                                    <SimpleMultiAnswersQuestion answers={this.props.yesSubAnswers} />
                                </label>
                            </div>
                       </div>
                   </div>  
                   ):null}

                   <div className='row'>
                       <div className='col-sm'>
                            <Field 
                            name={`${this.props.elementId}_${NO}`}
                            component={WrapCheckbox}
                            label={NO}
                            onChange={(e) => this.checkboxOnChange(e,NO)}
                            />
                       </div>
                   </div>
                </div>
            </ListItem>    
        )
    }
}

export default YesNoCheckboxItem


// WEBPACK FOOTER //
// ./src/components/QualityReview/YesNoCheckboxItem.js